import React from 'react'
import html5 from './img/html5.svg'
import css3 from './img/css3.svg'
import javascript from './img/javascript.svg'
import nodejs from './img/nodejs.svg'
import express from './img/express.svg'
import react from './img/react.svg'
import redux from './img/redux.svg'
import postgresql from './img/postgresql.svg'
import bootstrap from './img/bootstrap.svg'
import './tecnologias.css'
function Tecnologias() {
  return (
    <div>
      <h1 className="title-tec">Tecnologías</h1>

      <div className='contenedor-tecnologias'>
        <img src={html5}/>
        <img src={css3}/>
        <img src={javascript}/>
        <img src={nodejs}/>
        <img src={express}/>
        <img src={react}/>
        <img src={redux}/>
        <img src={postgresql}/>
        <img src={bootstrap}/>
      </div>
    </div>
  )
}

export default Tecnologias
